export default __webpack_public_path__ + "static/media/descobertas-mensais.0edb51c1.webp";